import { z } from 'zod';

// Mirrors Bizy::Blueprints::EarlyAccessRequestBlueprint (rendered with the
// `Key-Inflection: camel` header, so server snake_case arrives camelCased).
export const EarlyAccessRequestSchema = z.object({
	id: z.string(),
	companyId: z.string(),
	userId: z.string(),
	source: z.string(),
	status: z.enum(['new', 'contacted', 'granted']),
	requestedAt: z.string(),
	userName: z.string().nullable().optional(),
	companyName: z.string().nullable().optional(),
	/** Live signal: has the company been granted Bizy (participation flag on) since requesting? */
	companyBizyEnabled: z.boolean().optional(),
});

export type EarlyAccessRequest = z.infer<typeof EarlyAccessRequestSchema>;

export const EarlyAccessRequestListSchema = z.object({
	records: z.array(EarlyAccessRequestSchema),
	// `.nullish()` (number | null | undefined) because the server omits these on
	// some responses and sends `null` on others (e.g. an empty filtered set).
	// Plain `.optional()` rejects `null`, which would throw a ZodError and leave
	// React Query showing the previous successful result instead of refreshing.
	totalCount: z.number().nullish(),
	/** Distinct people across the filtered set (not rows) — drives the "N people applied" count. */
	applicantCount: z.number().nullish(),
	page: z.number().nullish(),
	perPage: z.number().nullish(),
});

export type EarlyAccessRequestList = z.infer<typeof EarlyAccessRequestListSchema>;
